import PropTypes from 'prop-types';
import React, {
  useCallback,
  // useEffect,
  // useMemo,
  useState,
} from 'react';
import Comments from 'components/Comments';

// import tracker, { TrackerFragments } from 'lib/tracker';

import CommentInner from './ReplyInner';

const CommentReplies = ({ comment, onRefresh, eventOrSponsorId, modal }) => {

  const [loading,
    //  setLoading
  ] = useState(false);

  return (
    <Comments
      // hasMore={hasNextPage}
      loading={loading}
    // onLoadMore={onLoadMore}
    >
      {/* {edges.map(reply)=>{
        return (
      <CommentInner
        comment={reply}
        key={reply.id}
      // onDelete={() => onDelete(reply)}
      // viewer={viewer}
      />
      )}} */}
      {comment.children.map(
        useCallback((reply) => {
          return (
            <CommentInner
              modal={modal}
              eventOrSponsorId={eventOrSponsorId}
              onRefresh={onRefresh}
              comment={reply}
              key={reply.id}
            // onDelete={() => onDelete(reply)}
            // viewer={viewer}
            />
          );
        }, [comment?.children]),
      )}

    </Comments>
  );
};

CommentReplies.propTypes = {
  eventOrSponsorId: PropTypes.object.isRequired,
  comment: PropTypes.object.isRequired,
  onRefresh: PropTypes.func.isRequired,
  modal: PropTypes.object.isRequired,
};

export default CommentReplies;
